export default "__VITE_ASSET__B7S9ERV7__"